import {
	Route, Switch, useRouteMatch
} from 'react-router';
// eslint-disable-next-line object-curly-newline
import { CreatePage } from '../../../../Pages';
import BillsCreatePage from '../../../../Pages/BillsPage/BillsCreatePage/BillsCreatePage';
import GRNsPage from '../../../../Pages/GRNPage/GRNsPage';

const GRNRoutes = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<Route exact path={`${path}`}>
				{/* <MyMachinesPage createPath={`${path}/add`} /> */}
				<GRNsPage createPath={`${path}/add`} />
			</Route>
			<Route exact path={`${path}/add`}>
				<CreatePage
					createPage={<BillsCreatePage />}
					entity='MACHINES'
				/>
			</Route>
		</Switch>
	);
};

export default GRNRoutes;
